{
  "version": 1,
  "asset_id": "d2f57b3b-821f-4e9d-b264-610180ecb195",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/d2f57b3b-821f-4e9d-b264-610180ecb195/vs-logistics.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/d2f57b3b-821f-4e9d-b264-610180ecb195/vs-logistics.png",
  "original_filename": "vs-logistics.png",
  "size": 12992,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:57Z"
}
